import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// v2.4 — small live ticker for the "PLAY WITH FRIENDS" CTA.
// Polls every 45s so it doesn't hammer the API.
export default function PartyLiveTicker() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const r = await axios.get(`${API}/party/stats/online`);
        if (!cancelled) setStats(r.data);
      } catch (e) {}
    };
    tick();
    const id = setInterval(tick, 45000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);
  if (!stats) return null;
  const active = stats.parties_active || 0;
  const day = stats.players_last_24h || 0;
  return (
    <span
      className="pvp-ticker inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-widest"
      data-testid="pvp-live-ticker"
      title={`${day} unique players in the last 24h · ${active} party rooms active right now`}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full pvp-ticker-dot" style={{ background: 'var(--red)' }} />
      {active > 0 ? `${active} LIVE` : `${day} TODAY`}
    </span>
  );
}
